import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { useExcelExport } from "@/hooks/export/useExcelExport";
import { Report } from "@/utilities/export/report";

export interface ExcelExportButtonProps {
  report: Report;
  disabled?: boolean;
}

/** Excel download for exports that are not a data grid. */
export function ExcelExportButton({ report, disabled }: ExcelExportButtonProps) {
  const { t } = useTranslation();
  const { exportExcel } = useExcelExport();

  return (
    <Button
      size="small"
      startIcon={<FileDownloadIcon />}
      disabled={disabled}
      onClick={() => void exportExcel(report)}
    >
      {t("export.excel")}
    </Button>
  );
}
